import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

const TEETH = [0, 45, 90, 135] as const;

export function AutomationsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <g transform="translate(80 80)">
        {TEETH.map((angle) => (
          <rect
            key={angle}
            x="-6"
            y="-42"
            width="12"
            height="84"
            rx="4"
            fill={c.p400}
            transform={`rotate(${angle})`}
          />
        ))}
        <circle r="31" fill={c.p500} />
        <circle r="17" fill={c.n0} />
        <path d="M4-12L-8 4H0l-4 12 12-17H0z" fill={c.a400} />
      </g>
    </Frame>
  );
}
